/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  buttonStyle: {
    '& button:focus': {
      backgroundColor: 'unset !important',
      color: '#222222 !important'
    },
    '& button:disabled': {
      background: 'transparent'
    }
  }
});

export default useStyles;
